var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"history-container"},[_c('PageTitle',{staticClass:"d-md-flex",attrs:{"text":"Historique des points"}}),_c('div',{staticClass:"container"},[_c('PointsHistory',{attrs:{"limit":_vm.pageLimit,"infinite":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }